import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { Base, IBase } from "mobx-stores/_models/base";
import {
  IAddMaterialGoodsReceiptItem,
  IUpdateMaterialGoodsReceiptItem,
  MaterialGoodsReceiptItem,
} from "./material-goods-receipt-item";

export const MaterialGoodsReceipt = types.compose(
  Base,
  types.model({
    receiptDate: types.maybeNull(types.string),
    items: types.optional(types.array(MaterialGoodsReceiptItem), []),
  })
);
export interface IMaterialGoodsReceipt
  extends Instance<typeof MaterialGoodsReceipt> {}
export interface IMaterialGoodsReceiptProperties
  extends SnapshotIn<typeof MaterialGoodsReceipt> {}

export interface IAddMaterialGoodsReceipt
  extends Omit<IMaterialGoodsReceiptProperties, keyof IBase> {
  items: IAddMaterialGoodsReceiptItem[];
}
export interface IUpdateMaterialGoodsReceipt
  extends Omit<IMaterialGoodsReceiptProperties, "items"> {
  items: IUpdateMaterialGoodsReceiptItem[];
}
